import gsap from 'gsap'

const dropdown = {
  init(): void {
    document.querySelectorAll<HTMLElement>('.dropdown').forEach((target: HTMLElement) => {
      this.handleDropdown(target)
    })
  },

  handleDropdown(target): void {
    const el = {
      head: target.querySelector('.dropdown__head'),
      body: target.querySelector('.dropdown__body'),
      bodyContent: target.querySelector('.dropdown__body-content'),
      links: target.querySelectorAll('.dropdown__link'),
      resetButton: target.querySelector('.dropdown__reset-button'),
      title: target.querySelector('.dropdown__title'),
    }

    let isAnimating = false

    const method = {
      init(): void {
        el.head.addEventListener('click', () => {
          method.toggleDropdown()
        })

        // Toggling links doesn't work in current setup because of page redirects

        // el.links.forEach((link) => {
        //   link.addEventListener('click', method.toggleLink)
        // })

        // el.resetButton.addEventListener('click', method.resetDropdown)

        // Different functionality for selected collection on page load

        el.links.forEach((link) => {
          if (window.location.search.includes(link.search)) {
            if (window.location.search.includes('collection')) {
              el.title.innerHTML = link.innerHTML
              target.classList.add('dropdown--link-selected')
            }
          }
        })

        if (el.resetButton && !target.closest('.product-page__variants')) {
          el.resetButton.addEventListener('click', () => {
            target.classList.remove('dropdown--link-selected')
            window.location.href = el.links[0].href
          })
        }

        // Handling dropdown on the product page for product variant

        if (target.closest('.product-page__variants')) {
          const discountPrice = document.querySelector<HTMLElement>('.product-page__discountPrice')
          const originalPrice = document.querySelector<HTMLElement>('.product-page__orgPrice')
          const addToCartButton = document.querySelector<HTMLButtonElement>('.product-page__add-to-cart-button')
          const variantId = document.querySelector<HTMLInputElement>('input[name=variantId]')
          const price = document.querySelector<HTMLElement>('.product-page__price')
          el.links.forEach((link) => {
            link.addEventListener('click', (event) => {
              event.preventDefault()
              method.toggleLink(event)
              if (discountPrice && originalPrice) {
                addToCartButton.disabled = false
                originalPrice.innerHTML = link.innerHTML

                const discountPercentage = Number.parseFloat(discountPrice.getAttribute('data-discount'))

                const priceString = link.innerHTML
                const numericPart = Number.parseFloat(priceString.replace(/\./g, '').replace(/[^0-9.-]+/g, ''))

                if (!Number.isNaN(numericPart)) {
                  // Ensure numericPart is a valid number
                  const newPrice = Math.round(numericPart * discountPercentage)

                  // Format the number with a thousands separator
                  const formattedPrice = newPrice.toLocaleString('da-DK') // "da-DK" for Danish locale, for example

                  discountPrice.innerHTML = `${formattedPrice} kr.`
                }
              } else {
                price.innerHTML = link.innerHTML
              }

              variantId.setAttribute('value', link.getAttribute('href'))
            })
          })

          if (el.resetButton) {
            el.resetButton.addEventListener('click', () => {
              method.resetDropdown()
              addToCartButton.disabled = true
              if (discountPrice && originalPrice) {
                originalPrice.innerHTML = ''
                discountPrice.innerHTML = ''
              } else {
                price.innerHTML = el.links[0].innerHTML
              }
              variantId.setAttribute('value', el.links[0].getAttribute('href'))
              setTimeout(() => {
                el.title.innerHTML = el.title.parentElement.getAttribute('title')
              }, 256)
            })
          }
        }
      },

      closeOnEscPress(event): void {
        if (event.key.match('Escape') && method.isActive()) {
          method.toggleDropdown()
        }
      },

      closeOnOutsideClick(event): void {
        if (!event.target.closest('.dropdown--active') && method.isActive()) {
          method.toggleDropdown()
        }
      },

      isActive(): boolean {
        return target.classList.contains('dropdown--active')
      },

      resetDropdown(): void {
        gsap
          .timeline()
          .to(el.title, {
            duration: 0.234,
            onComplete: () => {
              el.title.innerHTML = el.links[0].innerHTML
              target.classList.remove('dropdown--link-selected')
            },
            opacity: 0,
          })
          .to(el.title, {
            clearProps: 'all',
            duration: 0.321,
            opacity: 1,
          })
      },

      runAnimation(action): void {
        const props = {
          clearProps: 'all',
          duration: 0.543,
          ease: 'power3.inOut',
        }

        isAnimating = true

        gsap.fromTo(
          el.body,
          {
            height: action === 'open' ? 0 : el.body.offsetHeight,
          },
          {
            height: action === 'open' ? 'auto' : 0,
            ...props,
          }
        )

        gsap.fromTo(
          el.bodyContent,
          {
            clipPath: action === 'open' ? 'inset(0 0% 100% 0%)' : 'inset(0% 0% 0% 0%)',
          },
          {
            clipPath: action === 'open' ? 'inset(0% 0% 0% 0%)' : 'inset(0% 0% 100% 0%)',
            ...props,
          }
        )

        gsap.fromTo(
          el.links,
          {
            opacity: action === 'open' ? 0 : 1,
          },
          {
            delay: action === 'open' ? 0.1 : 0,
            opacity: action === 'open' ? 1 : 0,
            overwrite: true,
            stagger: action === 'open' ? 0.05 : 0,
            ...props,
          }
        )

        gsap.delayedCall(0.234, () => {
          isAnimating = false
        })
      },

      toggleDropdown(): void {
        if (isAnimating) {
          return
        }

        this.runAnimation(method.isActive() ? 'close' : 'open')

        if (method.isActive()) {
          el.head.ariaExpanded = 'false'
          target.classList.remove('dropdown--active')
          document.body.removeEventListener('click', method.closeOnOutsideClick)
          window.removeEventListener('keydown', method.closeOnEscPress)
        } else {
          el.head.ariaExpanded = 'true'
          target.classList.add('dropdown--active')
          document.body.addEventListener('click', method.closeOnOutsideClick)
          window.addEventListener('keydown', method.closeOnEscPress)
        }
      },

      toggleLink(event): void {
        method.toggleDropdown()

        gsap
          .timeline()
          .to(el.title, {
            duration: 0.234,
            onComplete: () => {
              el.title.innerHTML = event.target.innerHTML
              target.classList.add('dropdown--link-selected')
            },
            opacity: 0,
          })
          .to(el.title, {
            clearProps: 'all',
            duration: 0.321,
            opacity: 1,
          })
      },
    }

    method.init()
  },
}

export default dropdown
